/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFWappalyzerAggregatedData
 */
export interface CRSFWappalyzerAggregatedData {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFWappalyzerAggregatedData
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFWappalyzerAggregatedData
     */
    cpe?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFWappalyzerAggregatedData
     */
    cves: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFWappalyzerAggregatedData
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFWappalyzerAggregatedData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFWappalyzerAggregatedData
     */
    version?: string;
}

/**
 * Check if a given object implements the CRSFWappalyzerAggregatedData interface.
 */
export function instanceOfCRSFWappalyzerAggregatedData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "categories" in value;
    isInstance = isInstance && "cves" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CRSFWappalyzerAggregatedDataFromJSON(json: any): CRSFWappalyzerAggregatedData {
    return CRSFWappalyzerAggregatedDataFromJSONTyped(json, false);
}

export function CRSFWappalyzerAggregatedDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFWappalyzerAggregatedData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categories': json['categories'],
        'cpe': !exists(json, 'cpe') ? undefined : json['cpe'],
        'cves': json['cves'],
        'found': json['found'],
        'name': json['name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function CRSFWappalyzerAggregatedDataToJSON(value?: CRSFWappalyzerAggregatedData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categories': value.categories,
        'cpe': value.cpe,
        'cves': value.cves,
        'found': value.found,
        'name': value.name,
        'version': value.version,
    };
}

